// @flow

import './index.scss';
import * as React from 'react';
import classnames from 'classnames';
import uiStore from 'stores/ui';

type Props = {
    [prop: string]: any
};

const Button = ({ small = false, className = '', ...props }: Props): React.Node => {
    const classname = classnames(className, {
        'Button--small': small
    });

    if (uiStore.isStatic) {
        // eslint-disable-next-line global-require
        const { Button: UiKitButton } = require('@insolus/ui-kit');
        return <UiKitButton {...props} className={classname} />;
    }
    // eslint-disable-next-line global-require
    const { Button: RouterButton } = require('@insolus/react-router');
    return <RouterButton {...props} className={classname} />;
};

export default Button;
